import axios from "axios";
import { getCurrentLogedUserData } from ".";

import * as actionTypes from "./actionTypes";

export const initGetUserProfile = () => {
  return {
    type: actionTypes.INIT_GET_USER_PROFILE,
    userProfileLoading: true,
  };
};

export const successGetUserProfile = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_USER_PROFILE,
    userProfileLoading: false,
    userProfile: data.data,
  };
};

export const failGetUserProfile = (error) => {
  return {
    type: actionTypes.FAIL_GET_USER_PROFILE,
    userProfileLoading: false,
    error: error,
  };
};

export const getUserProfile = (bearerToken) => {
  const config = {
    headers: {
      Authorization: "Bearer " + bearerToken,
    },
  };
  return (dispatch) => {
    dispatch(initGetUserProfile());
    axios
      .get("users/me", config)
      .then((response) => {
        dispatch(successGetUserProfile(response.data));
      })
      .catch((error) => {
        dispatch(failGetUserProfile(error.message));
      });
  };
};

// ########################### EDIT USER PROFILE ###################:

export const initEditUser = () => {
  return {
    type: actionTypes.INIT_Edit_USER_PROFILE,
    userProfileLoading: true,
  };
};

export const successEditUser = (data) => {
  return {
    type: actionTypes.INIT_Edit_USER_PROFILE,
    userProfileLoading: false,
    userProfile: data.data,
  };
};

export const failEditUser = (error) => {
  return {
    type: actionTypes.INIT_Edit_USER_PROFILE,
    userProfileLoading: false,
    error: error,
  };
};

export const editUserProfile = (data) => {
  const bearerToken = window.localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + bearerToken,
    },
  };

  return (dispatch) => {
    dispatch(initGetUserProfile());
    axios
      .put("users/me", data, config)
      .then((response) => {
        // dispatch(getUserProfile(bearerToken))
        dispatch(getCurrentLogedUserData(bearerToken));
        dispatch(getUserProfileAddress(bearerToken));
      })
      .catch((error) => {
        dispatch(failGetUserProfile(error.message));
      });
  };
};

//User profile Address:
export const initGetUserProfileAddress = () => {
  return {
    type: actionTypes.INIT_GET_USER_PROFILE_ADDRESS,
    userProfileAddressLoading: true,
  };
};

export const successGetUserProfileAddress = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_USER_PROFILE_ADDRESS,
    userProfileAddressLoading: false,
    userProfileAddress: data.data,
  };
};

export const failGetUserProfileAddress = (error) => {
  return {
    type: actionTypes.FAIL_GET_USER_PROFILE_ADDRESS,
    userProfileAddressLoading: false,
    errorAddress: error,
  };
};

export const getUserProfileAddress = (bearerToken) => {
  const config = {
    headers: {
      Authorization: "Bearer " + bearerToken,
    },
  };
  return (dispatch) => {
    dispatch(initGetUserProfileAddress());
    axios
      .get("addresses", config)
      .then((response) => {
        dispatch(successGetUserProfileAddress(response.data));
      })
      .catch((error) => {
        dispatch(failGetUserProfileAddress(error.message));
      });
  };
};

//update user address
export const updateUserAddress = (data) => {
  const bearerToken = window.localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + bearerToken,
    },
  };
  return () => {
    axios
      .put(`addresses/${data.id}`, data, config)
      .then((res) => {
        console.log(res);
        getUserProfileAddress(bearerToken);
      })
      .catch((err) => console.log(err));
  };
};
